/**
 * Created by Josef Jurca on 7.3.2017.
 */

import _ from 'lodash';

import {convertFromRead as convertMediaFromRead} from './assets/media';
import {convertFromRead as convertMetaDataFromRead} from './assets/metadata';
import {convertFromRead as convertTagsFromRead} from './assets/tags';
import {convertImagesFromRead} from './images';

import LinearChannel from 'models/asset/linear';

/**
 * Converts application data for get linear channels request.
 *
 * @param {number} linearTypeId - Linear type id.
 * @returns {Object} Request data.
 */
export function convertForGetLinearChannels (linearTypeId) {

    return {
        filter: {
            'objectType': 'KalturaSearchAssetFilter',
            'typeIn': linearTypeId || 570
        },
        pager: {
            'pageSize': 30,
            'pageIndex': 1
        }
    };
}

/**
 * Converts read data to linear channels data.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Linear channels data.
 */
export function convertFromGetLinearChannels (response) {
    let channels = {};

    _.forEach(_.get(response, ['result','objects']), (item) => {
        item.images = convertImagesFromRead.call(this, item.images) || [];
        item.mediaFiles = convertMediaFromRead.call(this, item.mediaFiles) || [];
        item.metas = convertMetaDataFromRead.call(this, item.metas) || {};
        item.tags = convertTagsFromRead.call(this, item.tags) || {};

        if (!_.has(response, item.id)) {
            channels[item.id] = new LinearChannel(item);
        }
    });

    return {
        totalCount: response.result.totalCount || 0,
        objectType: response.result.objectType,
        channels
    };
}


// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/linearchannels.js